import { ConfigProps } from '@config/types'

const config = ({
  deploymentEnv,
  authUrl,
  pianoUrl,
  pianoSdkUrl,
}: ConfigProps) => ({
  tokenUrl: `${authUrl}/piano-token`,
  applicationId: deploymentEnv === 'prod' ? '77U9mvKhpu' : '5QrSF9r9su',
  pianoEndPoint: `${pianoUrl}/api/v3`,
  pianoSdkUrl: `${pianoSdkUrl}/api/tinypass.min.js`,
  pianoAdBlockDetectionScript: `(function(w,d,s){d.cookie = '__adblocker=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';var setNptTechAdblockerCookie = function (adblocker) {var date = new Date(); date.setTime(date.getTime() + 60 * 5 * 1000); d.cookie = '__adblocker=' + (adblocker ? 'true' : 'false') + '; expires=' + date.toUTCString() + '; path=/';};var script = d.createElement('script');script.setAttribute('defer',true);script.setAttribute('src','//www.npttech.com/advertising.js');script.setAttribute('onerror','setNptTechAdblockerCookie(true);'); d.getElementsByTagName('head')[0].appendChild(script);})(window,document,'script');`,
  experienceCookieName: '__pianoParams',
  cxenseSiteId: '1140849009057005855',
  modalZIndex: 10000000 + 1,
})

export type configType = ReturnType<typeof config>
export default config
